/**
 * Transaction History Component
 * Displays deposit and withdrawal history for a vault using DescriptionList pattern
 */

import { DescriptionList } from '@bitcoin-com/react-components/src/components/description-list'
import type { DescriptionListItem } from '@bitcoin-com/react-components/src/components/description-list/DescriptionList.types'

export interface Transaction {
  id: string
  type: 'deposit' | 'withdrawal'
  asset: string
  amount: string
  timestamp: Date
  txHash: string
}

interface TransactionHistoryProps {
  transactions: Transaction[]
}

export function TransactionHistory({ transactions }: TransactionHistoryProps) {
  if (transactions.length === 0) {
    return (
      <div className="text-center py-l">
        <p className="text-text-secondary font-['Satoshi_Variable'] text-[14px]">
          No transaction history yet. Deposit assets to get started.
        </p>
      </div>
    )
  }

  const items: DescriptionListItem[] = transactions.map((tx) => ({
    id: tx.id,
    label: new Date(tx.timestamp).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    }),
    value: (
      <div className="flex items-center justify-between w-full">
        <span className="font-['Satoshi_Variable'] font-medium text-[14px]">
          {tx.type === 'deposit' ? '↓' : '↑'} {tx.type === 'deposit' ? 'Deposit' : 'Withdrawal'}
        </span>
        <span className="font-['IBMPlexSans'] font-semibold text-[14px]">
          {tx.amount} {tx.asset}
        </span>
      </div>
    ),
    isNumeric: false
  }))

  return (
    <div className="space-y-m">
      <h3 className="font-display font-black text-heading-md uppercase text-text-primary">
        Transaction History
      </h3>
      <DescriptionList items={items} variant="responsive" />
    </div>
  )
}

